export const lowFilterOptions = [{text: 'Yes', value: true}, {text: 'No', value: false}]
export const disabledFilterOptions = [{text: 'Active', value: false}, {text: 'Disabled', value: true}]
export const clientTypeFilterOptions = [{text: 'Elite', value: 'Elite'}, {text: 'Diamond', value: 'Diamond'}]